import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';

import { ShippingInfo, UserCheckOutShippingDto } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { Step } from 'src/app/core/dtos/step';
import { CheckoutStepsService } from 'src/app/core/services/checkout-steps.service';
import { CheckoutService } from 'src/app/core/services/checkout.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { LoadingService } from 'src/app/core/services/loading.service';
import { CheckoutStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.scss']
})
export class ShippingComponent implements OnInit, OnDestroy {

  steps: Step[];
  checkoutShippingSubscription: Subscription;
  setShippingInfoSubscription: Subscription;
  launchSRDownload: boolean;
  hasPhysicalIPInCart: boolean;
  showShipping: boolean;
  checkoutShippingInfo: UserCheckOutShippingDto;
  shippingInfos: ShippingInfo[];
  brandId: BrandEnum;
  currentStep = 2;
  shippingMethodId: number;
  checkoutReviewUrl = "checkout/review";
  checkoutAddressUrl = "checkout/address";
  phoneNumber: string;

  constructor(
    private stepProgressService: StepProgressService,
    private configHelper: ConfigHelper,
    private loadingService: LoadingService,
    private checkoutService: CheckoutService,
    private checkoutStepsService: CheckoutStepsService,
    private router: Router,
    private toastService: HotToastService,
  ) {
    this.steps = this.stepProgressService.getCheckoutSteps(CheckoutStepEnum.Shipping);
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.phoneNumber = this.brandId === BrandEnum.CELPIP ? "1-800-958-5186" : "1-855-520-2235";
    this.launchSRDownload = this.configHelper.getLaunchSRDownload() === 1;
    this.getShippingInfo();
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  getShippingInfo() {
    this.loadingService.show();
    this.checkoutShippingSubscription = this.checkoutService.getShippingInfo()
      .subscribe(
        result => {
          this.checkoutStepsService.verifyData(this.currentStep, result.content.allowedStep);
          this.checkoutShippingInfo = result.content;
          this.shippingInfos = result.content.shippingInfos;
          this.hasPhysicalIPInCart = this.checkoutShippingInfo.isShippingNeeded;

          if (this.checkoutShippingInfo.showShipping === true) {
            this.showShipping = true;
          }
          else {
            this.showShipping = false;
            this.onNextClick();
          }

          if (this.shippingInfos.length > 0) {
            this.shippingMethodId = this.shippingInfos[this.checkoutShippingInfo.shippingInfoIndex].shippingMethodId;
          }

          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        });
  }

  selectShippingInfo(shippingInfo: ShippingInfo) {
    this.shippingMethodId = shippingInfo.shippingMethodId;
  }

  onNextClick() {
    this.loadingService.show();
    this.setShippingInfoSubscription = this.checkoutService.setShippingInfo(this.shippingMethodId)
      .subscribe(
        () => {
          this.loadingService.hide();
          this.router.navigate([this.checkoutReviewUrl]);
        },
        (error: HttpErrorResponse) => {
          let errorMsg = "Failed to save shipping information because of unknown problem. Please contact Paragon.";
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              errorMsg = errorMsg + "<br/>" + reasons;
            });
          }
          this.toastService.warning(errorMsg);
          this.loadingService.hide();
        }
      );
  }

  onBackClick() {
    this.router.navigate([this.checkoutAddressUrl]);
  }

  ngOnDestroy() {
    this.checkoutShippingSubscription?.unsubscribe();
    this.setShippingInfoSubscription?.unsubscribe();
  }

}
